<template>
  <div class="row subject_display">
    <h6>Subject</h6>
    <div class="row">
      <div class="col l3 m6 s12" v-for="item in data.course.subjects" v-bind:key="item.id" >
        <router-link :to="'/subject/'+item.id+'/'+data.course.id+'/'+$route.params.id">
        <div class="card card-content">
          <i class="material-icons">book</i>
          <p>{{ item.name }}</p>
        </div></router-link>
      </div>
    </div>
    
  </div>
</template>
<script>

export default {
  computed: {
    data() {
      return this.$store.getters.each_class;
    }
  },
  components: 
  {
   
  }
};
</script>
<style lang="scss" scoped>
 @import "@/style/colors.scss";
.subject_display {
  padding-top: 30px;
}
.subject_display .card {
  text-align: center;
  height:200px;
  display:flex;
  flex-direction: column;
  justify-content: center;
  border-radius: 50px;
}

.subject_display i 
{
    font-size:55px;
    color:$primaryColor;
}

</style>